import { Button } from '@library/components/buttons';
import { forwardRef } from 'react';

export interface UserMenuItemButtonProps {
  className: string;
  disabled: boolean;
  handleOnClick: () => void;
  message: string;
}

export const UserMenuItemButton = forwardRef<
  HTMLDivElement,
  UserMenuItemButtonProps
>(
  (
    { className, disabled, handleOnClick, message }: UserMenuItemButtonProps,
    ref
  ) => {
    return (
      <div ref={ref}>
        <Button
          className={className}
          disabled={disabled}
          name={`UserMenuItemButton-${message}`}
          onClick={handleOnClick}
          type="button"
        >
          {message}
        </Button>
      </div>
    );
  }
);
